import DOMPurify from 'dompurify';

export const HtmlRenderer = ({ htmlString }: { htmlString: string }) => {
  const cleanHtml = DOMPurify.sanitize(htmlString);

  return <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
};
